import '../styles/PublicPages.css';
import './About.css';
import demoCover from '../assets/cover-graphic.png';
import christianHeadshot from '../assets/headshot-christian.jpeg';
import anthonyHeadshot from '../assets/headshot-anthony.jpeg';

function About() {
	return (
		<div className='about-container'>
			<section className='about-hero'>
				<h1>About Assemblie</h1>
				<p>Building stronger church communities through technology</p>
			</section>

			<section className='about-content'>
				<div className='about-left'>
					<div className='about-section'>
						<h2>Our Mission</h2>
						<p>
							At Assemblie, we are dedicated to connecting
							churches and fostering stronger community bonds
							through innovative digital solutions. Our
							user-friendly, feature-rich application empowers
							churches of all sizes to engage, grow, and serve
							their communities with ease and effectiveness.
						</p>
					</div>

					<div className='about-section'>
						<h2>Our Story</h2>
						<p>
							Assemblie was founded out of a simple yet powerful
							need: to improve communication within a small
							church. What started as a solution to help a single
							congregation quickly grew into a robust platform
							capable of supporting churches of all sizes. Driven
							by a passion for fostering true connection within
							the church community, Assemblie was created to break
							down the barriers of communication and make it
							easier for churches to engage, grow, and serve.
						</p>
					</div>
				</div>

				<div className='about-right'>
					<h1>Meet the Founder</h1>
					<div className='founder-cards'>
						<div className='founder-card'>
							<img
								src={christianHeadshot}
								alt='Christian Lovern'
								className='founder-image'
							/>
							<h1 className='founder-name'>Christian Lovern</h1>
							<h2 className='founder-bio'>
								With over a decade of experience in worship
								leadership, Christian brings both musical talent
								and a deep passion for connecting people through
								faith. His vision for Assemblie stems from his
								firsthand understanding of how technology can
								enhance worship experiences and strengthen
								church communities.
							</h2>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}

export default About;
